var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumberTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#ABDFCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.62 35.588L24.056 30.368C24.536 29.888 25.208 29.264 26.072 28.496C27.44 27.248 28.484 26.24 29.204 25.472C29.924 24.704 30.512 23.888 30.968 23.024C31.424 22.136 31.652 21.188 31.652 20.18C31.652 18.692 31.22 17.564 30.356 16.796C29.492 16.004 28.232 15.608 26.576 15.608C25.448 15.608 24.284 15.812 23.084 16.22C21.908 16.628 20.804 17.228 19.772 18.02V14.492C21.788 13.028 24.248 12.296 27.152 12.296C29.744 12.296 31.76 12.992 33.2 14.384C34.64 15.752 35.36 17.624 35.36 20C35.36 21.152 35.108 22.256 34.604 23.312C34.124 24.368 33.44 25.412 32.552 26.444C31.664 27.452 30.464 28.688 28.952 30.152L24.056 34.94H36.296V38H18.62V35.588Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberTwo);
export default __webpack_public_path__ + "static/media/numberTwo.cff537d6e7789c7888f2b497c1955d57.svg";
export { ForwardRef as ReactComponent };